import e, { useState as a, useEffect as k } from "react";
import "@knocklabs/react-core";
import { Spinner as x } from "../../../core/components/Spinner/Spinner.mjs";

import "lodash.debounce";

import E from "./icons/CheckmarkIcon.mjs";
import d from "./icons/HashtagIcon.mjs";
import v from "./icons/LockIcon.mjs";

const j = ({
  channel: t,
  isLoading: o,
  isConnected: c,
  onClick: s,
  tabIndex: l,
  channelOptionProps: u,
  isUpdating: r
}) => {
  const [p, m] = a(!1), [n, i] = a(null), b = () => n === t.id && (r || o) ? /* @__PURE__ */ e.createElement(x, { thickness: 3 }) : p || c ? /* @__PURE__ */ e.createElement(E, { isConnected: c }) : /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__option__text-container__empty-icon" }), f = (_) => {
    i(_), s(_);
  };
  return k(() => {
    if (n && !r)
      return i(null);
  }, [o, r, n]), /* @__PURE__ */ e.createElement("button", { key: t.id, className: "rsk-combobox__option__button", onClick: () => !o && f(t.id), disabled: o || r, onMouseEnter: () => m(!0), onMouseLeave: () => m(!1), tabIndex: l, ...u }, /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__option__text-container" }, /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__option__text-container__connection-icon" }, b()), /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__option__text-container__channel-icon" }, t.is_private ? /* @__PURE__ */ e.createElement(v, null) : /* @__PURE__ */ e.createElement(d, null)), /* @__PURE__ */ e.createElement("div", { className: "rsk-combobox__option__text-container__text" }, t.name)));
};
export {
  j as default
};
//# sourceMappingURL=SlackChannelOption.mjs.map
